module.exports = __webpack_public_path__ + "img/2399@2x.1ee8c14f.png";